/* eslint-disable ember/no-classic-components, ember/no-runloop */
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { later } from '@ember/runloop';
import { getDynamicStyles } from '@linc-technologies/linced-common/utils/table';

@tagName('')
export default class DialogPrinter extends Component {
  // printStyles generates the base (static) styles for printing Finance report
  // dialogs.
  printStyles() {
    let origin = window.location.origin;
    return `
      <link rel="stylesheet" href="${origin}/assets/icons/linced-material.css">
      <style type="text/css">
        body {
          font-family: -apple-system, BlinkMacSystemFont, Inter, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        }

        h1, h2, h3, h4 {
          page-break-after: avoid;
        }

        .page-break {
          page-break-before: always;
        }

        .layout-row {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
        }
        .layout-column {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .layout-column > div{
          width: 100%;
        }
        .layout-align-start-center {
          align-items: center;
        }
        .layout-align-space-between-center {
          align-items: center;
          justify-content: space-between;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, th.md-column, th.border-left {
          text-align: left;
          padding-left: 3px;
        }
        th, td {
          padding: 3px;
        }
        tr th:not(:last-child),
        tr td:not(:last-child) {
          padding-right: 12px;
        }
        table tbody tr,
        table tfoot tr {
          border-top: 1px solid #aeaeae;
        }

        td.blacked-out {
          background-color: #757575;
        }

        tr.cancelled-transaction {
          text-decoration: line-through;
        }

        md-checkbox {
          position: relative;
          margin-top: 12px;
        }
        md-checkbox .md-container {
          position: absolute;
          left: 0;
          display: inline-block;
        }
        md-checkbox .md-container .md-icon {
          width: 16px;
          height: 16px;
          border: 2px solid #757575;
        }
        md-checkbox .md-label {
          margin-left: 30px;
          margin-right: 0;
          box-sizing: border-box;
          position: relative;
        }

        .school-banner {
          display: flex;
          align-items: center;
          padding-bottom: 8px;
          border-bottom: 1px solid grey;
        }
        .school-banner .logo {
          height: 60px;
          margin-right: 10px;
        }
        .school-banner h1 {
          font-weight: normal;
          margin: 0;
        }
        .school-address-banner {
          width: 100%;
          padding-bottom: 8px;
          border-bottom: 1px solid grey;
        }
        .school-address-banner h4 {
          font-weight: normal;
          margin: 0;
          width: 100%;
          display: block;
        }

        img {
          margin: 0 16px 16px 0;
        }

        .report-intro,
        .report-intro-image,
        .attendance,
        .posts,
        .goals,
        .progress,
        .assessment {
          margin-bottom: 36px;
        }

        .page {
          page-break-after: always;
        }

        h2.page-title {
          font-size: 1.35em;
        }
      </style>
    `;
  }

  @action
  handlePrint() {
    // Gather styles and HTML.
    let styles = this.printStyles() + getDynamicStyles();
    let parent = this.parentView.element;
    let title = parent.querySelector('md-dialog > md-toolbar h2').innerText;
    let report = parent.querySelector('md-dialog-content').cloneNode(true);
    // Replace inputs with just their value.
    report.querySelectorAll('input').forEach((input) => {
      let textNode = document.createTextNode(input.value);
      input.parentNode.replaceChild(textNode, input);
    });
    let content = report.innerHTML;
    content = `<h2>${title}</h2>${content}`;

    // Inject styles and HTML into the iframe.
    let printer = parent.querySelector('iframe');
    printer.contentDocument.title = title;
    printer.contentDocument.body.className = 'report-print';
    printer.contentDocument.body.innerHTML = styles + content;

    // Trigger the actual printing ~500ms after content insertion.
    later(printer.contentWindow, 'print', 500);
  }
}
